import { render, staticRenderFns } from "./HeaderNavComponent.vue?vue&type=template&id=5ed69a4c&scoped=true&"
import script from "./HeaderNavComponent.vue?vue&type=script&lang=js&"
export * from "./HeaderNavComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNavComponent.vue?vue&type=style&index=0&id=5ed69a4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed69a4c",
  null
  
)

export default component.exports